import { TelemetryClient } from '@jarvis/web-stratus-client';

export default async function getJobsPrintAreaCounters({
  stack,
  authProvider,
  startDate,
  endDate,
  numDays,
}) {
  const client = new TelemetryClient(stack, authProvider);
  const response = await client.getPrintCountersByTenancy(undefined, undefined, startDate, endDate, numDays);

  return response;
}
